import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enJson from './locale/en.json';
import cnJson from './locale/cn.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enJson },
      cn: { translation: cnJson },
    },
    lng: 'cn',
    fallbackLng: 'cn',
    interpolation: { escapeValue: false },
    react: { useSuspense: true },
  });

export default i18n;